import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const';

let routes: RouteRecordRaw[] = [
    {
        path: '/pdfInterpolationTemplates',
        name: 'pdfInterpolationTemplates',
        component: () => import('./views/pdfInterpolationTemplates.vue'),
        meta: { sideMenuLabel: "Template pdf" },
    },
    {
        path: '/pdfInterpolation/:identifier',
        name: 'pdfInterpolationTemplateDetail',
        component: () => import('./views/pdfInterpolationTemplateDetail.vue'),
    },
];

export default routes;
